if ($("#_fileUpload").length > 0) {
    var jsApplicationId = '';
    var jsPortalFileId = '';
    var jsApplicantId = '';
    var jsFileUploadId = '';
    var jsParentUserId = '';
    var FileId;
    var SourceId;
    var ApplicantId;
    var PersonTypeCd;
    $(document).on('change', "#_fileUpload input:file", function () {
        var fileName = $(this).val();
        $("#fileExtError").addClass("d-none");
        if (!fileName) return;

        const extList = ".bmp,.jpg,.jpeg,.gif,.png,.pdf,.tiff,.heif,.hevc".split(',');
        let isvalidExtension = false;
        for (const item of extList) {
            if (fileName.toLowerCase().endsWith(item)) {
                isvalidExtension = true;
                break;
            }
        }
        if (!isvalidExtension) {
            $("#fileExtError").removeClass("d-none");
            return;
        }

        $(".maxfilesizeerror").addClass('d-none');
        $("#uploaderror").addClass('d-none');

        var formData = new FormData();
        var d = $(this)[0].files[0];

        var maxfilesize = $(this).data('maxfilesize');

        if (d.size > maxfilesize) {
            $(".maxfilesizeerror").removeClass("d-none");
            $(".loadingBackground").hide();

            return;
        }

        $("#_fileUpload .btnUpload").prop('disabled', true); // no double post
        var url = '';
        if (location.href.indexOf('/en/') > 0) {
            $(".loading-text").html("Please wait while we upload and process your file.");
            url = location.href.split('/en/')[0] + '/en/FileUpload/UploadFile/';
        } else {
            $(".loading-text").html("Veuillez patienter pendant que nous téléchargeons et traitons votre fichier.");
            url = location.href.split('/fr/')[0] + '/fr/FileUpload/UploadFile/';
        }

        $(".loadingBackground").show();

        jsApplicationId = $(this).data('sourceid');
        jsApplicantId = $(this).data('applicantid');
        jsClientUserId = $(this).data('clientuserid');
        // Generic fields for all request types
        formData.append('File', d);
        formData.append('SourceId', jsApplicationId);
        formData.append('RequestTypeCd', $(this).data('requesttypecd'));
        // Parent Subsidy specific
        formData.append('ApplicantId', jsApplicantId);
        formData.append('PersonTypeCd', $(this).data('persontypecd'));
        formData.append('ParentUserId', jsClientUserId);
        formData.append('DocTypeId', $("#_uploadDocTypes").val());

        $("#_fileUpload .btnUpload").find('i.fa-file-upload').removeClass('fa-file-upload').addClass('fa-spinner fa-spin');
        $("#_fileUpload .btnUpload").prop('disabled', true).attr('disabled', 'disabled');

        $.ajax({
            url: url,
            method: 'POST',
            contentType: false,
            processData: false,
            data: formData,
            success: function (res) {

                $("#_fileUpload .btnUpload").prop('disabled', false);
                console.log(res);
                if (res && res.result === 0 && res.error) {
                    $(".loadingBackground").hide();
                    $("#uploaderror").removeClass("d-none");
                    return;
                }
                else {

                    // Hide any errors that exist on the page
                    $(".file-error-alert").addClass("d-none"); // TODO: remove? I don't think this is used

                    $(".loadingBackground").hide();

                    jsPortalFileId = res.portalFileId;
                    jsFileUploadId = res.fileId;
                    // skip PDFs for now
                    var viewer = $("#viewUploadedDocModal");
                    if (!res.mimeType.endsWith("pdf") && viewer && viewer.length == 1) {
                        //loadViewer($("#_fileUpload").data('requesttypecd'), jsPortalFileId, jsClientUserId);
                        SetUpViewer([jsPortalFileId], $("#_fileUpload").data('requesttypecd'), jsClientUserId);
                    } else {
                        window.onbeforeunload = null;
                        location.reload(true);
                    }
                }


            },
            error: function () {
                // Hide any errors that exist on the page
                $(".file-error-alert").addClass("d-none");

                $("#_fileUpload .btnUpload").prop('disabled', false);
                $(".loadingBackground").hide();
                $("#uploaderror").removeClass("d-none");
            }
        });


        $("#btnTryAgain").on("click", function () {

            deleteDocument(jsFileUploadId);

        });

        $("#btnContinue").on("click", function () {
            window.onbeforeunload = null;
            location.reload(true);
        });



        $("#btnCancel").on("click", function () {
            var deleteurl = '';

            deleteDocument(jsFileUploadId);

        });


        $(window).on("resize", rescale);

        window.setSize = rescale;


    }); // ready


    // if you don't want the window reloaded on success/fail, pass in onSuccess and onFailure functions
    function deleteDocument(fileUploadId, onSuccess, onFailure) { // default to jsFileUploadId
        // delay the window for a bit, in case this happens really fast
        window.setTimeout(function () { $(".loadingBackground").show(); }, 500);


        if (!onSuccess) {
            onSuccess = function () { location.reload(true); }
        }


        if (!onFailure) {
            onFailure = function () { location.reload(true); }
        }

        var formData = new FormData();

        // todo make sure fields are on Enrolment/View
        formData.append('FileUploadId', fileUploadId);
        formData.append('SourceId', $("#_fileUpload").data('sourceid'));
        formData.append('ApplicantId', $("#_fileUpload").data('applicantid'));
        formData.append('ClientUserId', $("#_fileUpload").data('clientuserid'));
        formData.append('RequestTypeCd', $("#_fileUpload").data('requesttypecd'));


        var deleteurl = '';

        if (location.href.indexOf('/en/') > 0) {
            deleteurl = location.href.split('/en/')[0] + '/en/FileUpload/Delete';
        } else {
            deleteurl = location.href.split('/fr/')[0] + '/fr/FileUpload/Delete';
        }

        $.ajax({
            url: deleteurl,
            method: 'POST',
            contentType: false,
            processData: false,
            data: formData,
            success: function (res) {
                // TODO show error if res.result < 1
                onSuccess();
                $(".loadingBackground").hide();
            },
            error: function () {
                // TODO show error
                onFailure();
                $(".loadingBackground").hide();
            }
        });

    }

} // if ($("#_fileUpload").length > 0) {
